import type { FunctionComponent } from 'react';
import { Link } from 'react-router';

import { Badge } from '~/ui/core/badge/Badge';

import { useUrlTiles } from '../../url-tiles/use-url-tiles';
import { createTaskClusterUrl, TASK_CLUSTER_NAVIGATION_STATE } from './task-cluster-url';

export const TaskClusterLinks: FunctionComponent<{
    readonly architectureId: string;
    readonly clusters: readonly { readonly id: string; readonly name: string }[];
    readonly testId: string;
}> = ({ architectureId, clusters, testId }) => {
    const { tiles } = useUrlTiles();

    return (
        <ul className="m-0 flex list-none flex-wrap justify-end gap-xs p-0" data-testid={testId}>
            {clusters.map((cluster) => (
                <li key={cluster.id}>
                    <Link
                        className="rounded-full focus-visible:outline focus-visible:outline-focus-ring"
                        state={TASK_CLUSTER_NAVIGATION_STATE}
                        to={createTaskClusterUrl({
                            architectureId,
                            clusterId: cluster.id,
                            tileValues: tiles.map((tile) => tile.value),
                        })}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <Badge className="hover:underline" variant="gray">
                            {cluster.name}
                        </Badge>
                    </Link>
                </li>
            ))}
        </ul>
    );
};
